import React from 'react';
import { VCredit } from './VCredit';

export const BetWinOverlay = ({ round, prefix }) => round?.payout_minor > round?.bet_minor ? <div className="keno-win-overlay" data-testid={`${prefix}-win-overlay`} role="status">
  <strong data-testid={`${prefix}-win-multiplier`}>{round.multiplier.toFixed(2)}×</strong><div className="keno-win-divider" aria-hidden="true" />
  <span className="keno-win-amount"><VCredit minor={round.payout_minor} testid={`${prefix}-win-payout`} /></span>
</div> : null;